import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Environment } from '../../../environments/environment.interface';

@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    private platformId = inject(PLATFORM_ID);
    private readonly env = environment as Environment;

    public get apiUrl(): string {
        return isPlatformBrowser(this.platformId) && localStorage.getItem('apiUrl') !== null
            ? localStorage.getItem('apiUrl') as string
            : this.env.apiUrl;
    }

    public get matomoUrl(): string {
        return this.env.matomoUrl;
    }

    public get baseUrl(): string {
        return this.env.baseUrl;
    }

    public get environment(): string {
        return this.env.environment;
    }

    public get version(): string {
        return this.env.version;
    }

    public get isLocal(): boolean {
        return this.env.environment === 'local';
    }

    public get isProduction(): boolean {
        return this.env.environment === 'production';
    }
}
